<template>
  <slot></slot>
  <modal :id="modalId" :title="title">
    <form :id="formId" :action="action" method="POST">

      <div class="form-group row" :class="{'has-error': !data.contactedAt}">
        <label for="contacted_at" class="col-form-label col-sm-2">Contact Date:</label>
        <div class="col-sm-10">
          <datepicker
            v-model="data.contactedAt"
            :max-date="maxDate"
            :invalid-state="!data.contactedAt"
            name="contacted_at">
          </datepicker>
        </div>
      </div>
      <div class="form-group row" :class="{'has-error': !data.contactPerson.trim().length}">
        <label for="contact_person" class="col-form-label col-sm-2">Contact Person:</label>
        <div class="col-sm-10">
          <input id="contact_person" name="contact_person" class="form-control form-control-sm"
                 placeholder="Contact person..." v-model="data.contactPerson">
        </div>
      </div>
      <div class="form-group row">
        <label for="contact_method" class="col-form-label col-sm-2">Contact Method:</label>
        <div class="col-sm-10">
          <chosen id="contact_method" name="contact_method"
                  :options="contactMethods"
                  placeholder="Select contact method..."
                  class="form-control form-control-sm"  v-model="data.contactMethod"></chosen>
        </div>
      </div>
      <div class="form-group row">
        <label for="comments" class="col-form-label col-sm-2">Comments:</label>
        <div class="col-sm-10">
          <textarea id="comments" class="form-control form-control-sm" name="comments"
                    placeholder="Enter any comments related to the contact..."
                    rows="5" v-model="data.comments"></textarea>
        </div>
      </div>

      <input type="hidden" name="contact_type" :value="contactType">

      <input type="hidden" name="_method" value="PATCH">
      <input type="hidden" name="_token" :value="$csrf_token">
    </form>

    <template #footer>
      <button type="button" class="btn btn-default" @click="hideModal">
        <i class="fa fa-fw fa-close"></i> Cancel
      </button>
      <button type="submit" class="btn btn-primary" :disabled="!submitEnable" name="submit_examiner_contact" :form="formId">
        <i class="fa fa-fw fa-save"></i> Submit
      </button>
    </template>

  </modal>
</template>

<script>
import HasModal from "./../mixins/HasModal";
export default {

  /**
   *
   * Modal form used to set claim examiner contact date and related data.
   *
   * Input properties:
   *
   * modalId - custom id for modal component.
   * action  - form action URL.
   * title   - form title.
   *
   * Usage examples:
   *
   * <examiner-contact-modal modal-id="examinerContactModal"
   *                         action="{{ route('claims.submit', compact('claim')) }}"
   *                         title="Examiner Contact"
   *                         contact-type="{{ \Cims\Models\InsuredContact::BY_EXAMINER }}"
   *                         :contact-methods="{{ json_encode(\Cims\Models\LookupList::listItems('contact_method')) }}">
   *   <a href="#" class="" v-modal="'examinerContactModal'">Update</a>
   * </examiner-contact-modal>
   *
   */

  mixins: [HasModal],

  props: {

    // Modal dialog id.
    modalId: {
      required: false,
      type: String,
      default: 'examinerContactModal'
    },

    // Form action URL.
    action: {
      type: String,
      default: ""
    },

    // Form title.
    title: {
      type: String,
      default: ""
    },

    // Contact type.
    contactType: {
      required: true,
      type: String,
    },

    // Contact methods.
    contactMethods: {
      required: true,
      type: Object,
    },

    contactedAt: {
      type: String,
      default: ""
    },

    contactMethod: {
      type: String,
      default: ""
    },

    contactPerson: {
      type: String,
      default: ""
    },

    comments: {
      type: String,
      default: ""
    },

  },

  /**
   * Variables (models).
   */
  data() {
    return {
      data: {
        contactedAt: this.contactedAt,
        contactMethod: this.contactMethod,
        contactPerson: this.contactPerson,
        comments: this.comments,
      }
    }
  },

  /**
   * Computed values
   */
  computed: {

    formId() {
      return this.modalId + "-form"
    },

    submitEnable() {
      return this.data.contactedAt && !!this.data.contactPerson.trim().length;
    },

    maxDate() {
      return moment(new Date()).set({hour: 23, minute: 59, second: 59, millisecond: 999}).format('MM/dd/yyyy');
    },

  }
}
</script>
